import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoginRedirectService } from './login-redirect.service';
import { SsoOptionsService } from './sso-options.service';

const UNAUTHORIZED_HTTP_STATUS = 401;
const isUnauthorizedHttpStatus = ({ status }) => status === UNAUTHORIZED_HTTP_STATUS;

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private locationState: LoginRedirectService,
    private ssoOptions: SsoOptionsService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.ssoOptions.alreadyRedirected) {
      return EMPTY; // returning EMPTY to prevent multiple redirection.
    }
    return next.handle(request).pipe(catchError(this.isUnauthorizedResponse));
  }

  private isUnauthorizedResponse = (response: any) => {
    if (
      response instanceof HttpErrorResponse &&
      isUnauthorizedHttpStatus(response) &&
      !this.ssoOptions.alreadyRedirected
    ) {
      this.ssoOptions.alreadyRedirected = true;
      return this.locationState.redirectWithState();
    }
    return throwError(() => response);
  };
}
